import React, { useState } from "react";
import { useHistory } from "react-router";
import Toast from "components/Toast";
import InputField from "components/InputField";
import Button from "components/Button";
import { addFormTemplate } from "core/services/api";
//import Button from "react-bootstrap/esm/Button"
//import Button from "../../../../components/Button"


function AddNewFormTemplate() {
  const history = useHistory();
  const [formName, setFormName] = useState('');
  const [jsonValue, setJsonValue] = useState('');
  const [isValidJson, setIsValidJson] = useState(true);
  const [displayToast, toggleDisplayToast] = useState<any>()

  const handleJsonChange = (event: any) => {
    const inputValue = event.target.value;
    setJsonValue(inputValue);

    try {
      JSON.parse(inputValue);
      setIsValidJson(true);
    } catch (error) {
      setIsValidJson(false);
    }
  };

  const handleSave = () => {
    const jsonContent = JSON.parse(jsonValue);
    if (typeof jsonContent === 'object' && jsonContent !== null && Object.keys(jsonContent).length > 0) {
      const data = {
        type: "CONSENT",
        subType: formName,
        centers: null,
        data: [
          {
            part: "",
            json: jsonContent
          }
        ],
        writeRights: null,
        readRights: null,
      };


      addFormTemplate(data)
        .then((res: any) => {
          toggleDisplayToast({ text: "Form Template Added Successfully", type: "success" });
        })
        .catch((err: any) => {
          toggleDisplayToast({ text: "Cannot Add Form Template", type: "error" });
        });
    }
    else {
      toggleDisplayToast({ text: "Invalid JSON content", type: "error" });
    }
  };

  return (
    <div className='add-new-form-template-container'>
      <div className="add-new-referral-container">
        <div className="add-new-referral-heading">
          <div
            className="approval-back-image"
            onClick={() => {
              history.push("/forms-v2")
            }}
          >
            <img
              src={'../../../assets/images/back-icon.svg'}
              height={'60px'}
              width={'60px'}
              alt="back button"
              className="back_button"
            />
          </div>

          <div className="add-new-text">Add New Consent Template</div>
        </div>

        <div className="add-new-referral-details">
          <div className="row nameDetails">
            <div className="col-2">
              <label className="textlabel">Form Name:</label>
            </div>
            <div className="col-3">
              <div className="custom-react-select">
                {/* Input field for Form Name */}
                {/* <input
                  type="text"
                  name="formName"
                  className="input-form-add"
                  value={formName}
                  onChange={(e) => }
                  placeholder="Enter Form Name"
                /> */}
                <InputField
                  placeholder="Name"
                  value={formName}
                  handleChange={(e: any) =>
                    setFormName(e.target.value)
                  }
                // readOnly={readOnly}

                />
              </div>
            </div>
          </div>

          <div className="row nameDetails">
            <div className="col-2">
              <label className="textlabel">JSON:</label>
            </div>
            <div className="col-3">
              <div className="custom-react-select">
                {/* Textarea for JSON */}
                <textarea
                  name="jsonInput"
                  style={{ resize: 'both' }}
                  value={jsonValue}
                  onChange={handleJsonChange}
                  rows={10}
                  cols={30}
                />
                {!isValidJson && (
                  <div style={{ color: 'red' }}>Invalid JSON format. Please check your input.</div>
                )}
              </div>
            </div>
          </div>

          <div className="button-alignment">
            {/* Save Button */}

            {/* <Button
              style={{ height: "40px" }}
              onClick={() => handleSave()}
            >
              Save
            </Button> */}
            <Button text="Save"
              onClick={() => handleSave()}
              type="submit" id="save" />
          </div>
        </div>
      </div>
      {displayToast && (
        <Toast
          textMessage={displayToast?.text}
          type={displayToast?.type}
          onClose={() => {
            toggleDisplayToast(false)
          }}
          onCloseText="Close"
          onClickText={null}
        />
      )}
    </div>
  );
}

export default AddNewFormTemplate;
